import { Box, Dialog, DialogContent } from '@mui/material'
import FeatureChip from './feature_chip'
import { Plan } from '../../api/models/model_product_detail'
import { useState } from 'react'
import { getPlanPriceDetails } from '../../utils/helper_functions_components'
import PlanDetailPage from '@/pages/price/price_detail'
import { Link, useNavigate } from 'react-router-dom'

interface PlanCardProps {
    plan: Plan
    billing: string
    showMore: boolean
    setShowMore: React.Dispatch<React.SetStateAction<boolean>>
}

export default function PlanCard({ plan, billing, setShowMore, showMore }: PlanCardProps) {
    const [open, setOpen] = useState(false)
    const hasMoreThanFiveFeatures = plan.feature_mappings && plan.feature_mappings.length > 5
    const remainingFeaturesCount = hasMoreThanFiveFeatures ? plan.feature_mappings.length - 5 : 0

    return (
        <div>
            <div
            // onClick={() => {
            //   setOpen(true);
            // }}

            // className='items-start p-4 rounded-lg shadow-md w-full h-full'
            >
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <Link to={`/price/plan?id=${plan.id}`}>
                        <h2 className={'font-inter font-semibold text-lg'}>{plan.name}</h2>
                    </Link>
                    {/* <BorderColorOutlined /> */}
                </Box>
                <div className="h-[19px]"></div>

                {/* {getPlanPriceDetails(plan.prices!, billing === 'Monthly')} */}
                {getPlanPriceDetails(plan.prices!, billing === 'Monthly')}

                <div className="h-3"></div>

                {plan.feature_mappings && (
                    <>
                        {plan.feature_mappings
                            .slice(0, showMore ? plan.feature_mappings.length : 5)
                            .map((feature, index) => (
                                <FeatureChip key={index} feature={feature} />
                            ))}
                    </>
                )}

                {hasMoreThanFiveFeatures && (
                    <div className={'flex justify-start my-2'}>
                        <button
                            onClick={() => setShowMore(!showMore)}
                            className={'font-semibold text-primary   text-[0.95rem]'}
                        >
                            {showMore ? '- Show Less' : `+ Show ${remainingFeaturesCount} More`}
                        </button>
                    </div>
                )}
            </div>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                fullWidth
                maxWidth="lg"
                sx={{
                    '& .MuiDialog-paper': {
                        width: '70%', // Custom width
                        maxWidth: 'none', // Remove the default maxWidth
                    },
                }}
            >
                <DialogContent
                    sx={{
                        justifyContent: 'space-between',
                        width: '100%',
                    }}
                >
                    <PlanDetailPage plan={plan} />
                </DialogContent>
            </Dialog>
        </div>
    )
}
